import { Component, OnDestroy, OnInit } from '@angular/core';
import { HelperService } from '@shared/services/helper.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-helper-form-icon',
  template: `<i
    class="fa fa-question-circle mr-1"
    [class.text-primary]="!hasView"
    (click)="onIconClick()"
  ></i> `,
  styles: [
    `
      i {
        cursor: pointer;
        font-size: 16px;
      }
    `,
  ],
})
export class HelperFormIconComponent implements OnInit, OnDestroy {
  hasView: boolean;
  private subscription = new Subscription();

  constructor(private helperService: HelperService) {}

  public ngOnInit(): void {
    this.subscription.add(
      this.helperService.onFormHelpChange.subscribe((view: boolean) => (this.hasView = view))
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onIconClick(): void {
    this.helperService.toggleFormHelpView();
  }
}
